import { BrandNotFound } from '@/app/components/BrandNotFound/BrandNotFound'
import SurveyObserver from '@/app/components/SurveyObserver'

export default function BrandNotFoundEnergySystemPageSurvey() {
  return (
    <SurveyObserver observedSurveys={['MissingBrand']}>
      <BrandNotFound
        type="battery"
        brandPlaceholder="Battery Brand"
        modelPlaceholder="Battery Model"
      />
    </SurveyObserver>
  )
}
